import { useState, useEffect } from "react";
import { Volume2, Square } from "lucide-react";
import { useT } from "../context/LanguageContext";

// Reads the given text aloud in English using the browser's speech engine (English only).
export function ListenButton({ text, testid = "listen-btn", className = "" }) {
  const { t, lang } = useT();
  const [speaking, setSpeaking] = useState(false);
  const ttsOk = typeof window !== "undefined" && "speechSynthesis" in window;

  useEffect(() => () => { if (ttsOk) window.speechSynthesis.cancel(); }, [ttsOk]);
  // Browser text-to-speech only reads English clearly; hide it for Shona/Ndebele
  // (admins provide recorded voice announcements for those instead).
  if (!ttsOk || !text || lang !== "en") return null;

  const toggle = () => {
    if (speaking) { window.speechSynthesis.cancel(); setSpeaking(false); return; }
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(t(text));
    u.lang = "en-US";
    u.rate = 0.95;
    u.onend = () => setSpeaking(false);
    u.onerror = () => setSpeaking(false);
    setSpeaking(true);
    window.speechSynthesis.speak(u);
  };

  return (
    <button type="button" onClick={toggle} data-testid={testid} title={t("Listen")}
      className={`inline-flex items-center gap-1 text-xs font-semibold text-clinical hover:opacity-80 transition-opacity ${className}`}>
      {speaking ? <><Square className="w-3.5 h-3.5" /> {t("Stop")}</> : <><Volume2 className="w-3.5 h-3.5" /> {t("Listen")}</>}
    </button>
  );
}
